import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError, BehaviorSubject } from 'rxjs';
import { catchError, switchMap, filter, take, finalize } from 'rxjs/operators';
import { Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class InterceptorService implements HttpInterceptor {
  private refreshTokenInProgress = false;
  private refreshTokenSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);

  constructor(
    private router: Router,
    private authService: AuthService,
  ) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    request = this.addAuthenticationToken(request);

    return next.handle(request).pipe(
      catchError((err: HttpErrorResponse) => {
        if (request.url.includes("Login")) {
          if (request.url.includes("Refresh")) {
            this.authService.logout();
            this.router.navigateByUrl('/home');
          }
        }

        if (err.status === 401) {
          if (err.headers.has('Token-Expired')) {
            if (this.refreshTokenInProgress) {
              return this.refreshTokenSubject.pipe(
                filter(result => result !== null),
                take(1),
                switchMap((res) => {
                  return next.handle(this.addAuthenticationToken(request))
                }));
            }

            else {
              this.refreshTokenInProgress = true;
              this.refreshTokenSubject.next(null);
              var refreshToken = this.authService.getRefreshToken();
              var token = this.authService.getToken();
              let body = { "IdUser": '', "Token": token, "RefreshToken": refreshToken };

              return this.authService.refreshToken(body).pipe(

                switchMap((resp) => {
                  if (resp) {
                    this.refreshTokenSubject.next(resp.token);

                    let newReq = this.addAuthenticationToken(request);
                    return next.handle(newReq);
                  }

                  this.authService.logout();
                  return throwError(err);
                }),
                catchError(_err => {
                  this.authService.logout();
                  return throwError(err);
                }),
                finalize(() => {
                  this.refreshTokenInProgress = false;
                })
              );
            }
          }
          else {
            this.authService.logout();
            this.router.navigateByUrl('/home');
            return throwError(err);
          }
        }
        else {
          return throwError(err);
        }
      })
    );
  }

  addAuthenticationToken(request) {
    const accessToken = this.authService.getToken();

    if (!accessToken) {
      return request;
    }

    return request.clone({
      setHeaders: {
        Authorization: `Bearer ${accessToken}`
      }
    });
  }
}
